import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";
import { SpringsCoverageMap } from "@/components/SpringsCoverageMap";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "hvac-seo-colorado-springs")!;

export const Route = createFileRoute("/hvac-seo-colorado-springs")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => (
    <>
      <IntersectionPage config={CONFIG} />
      <SpringsCoverageMap />
    </>
  ),
});
